<app-title-bar rootBreadCrumbs="['i18n.core.navigation.vendor-score-card']" titleText="i18n.core.navigation.vendor-score-card-vendors"></app-title-bar>
<div class="control-section overflow-x">
  <ejs-grid #grid
            class="grid-with-toolbar"
            width='100%'
            rowHeight='38'
            [dataSource]='data'
            [allowSorting]='true'
            [filterSettings]='filterSettings'
            [allowFiltering]='true'
            [allowPaging]='true'
            [enableHover]='true'
            [allowSelection]='true'
            [pageSettings]='pageSettings'
            [editSettings]='customEditSettings'
            [searchSettings]="searchOptions"
            [toolbar]="toolbarOptions"
            (actionBegin)="actionBegin($event)"
            (actionComplete)="actionComplete($event)"
            (toolbarClick)="toolbarClickHandler($event)"
            (commandClick)="commandClick($event)"
            (rowDataBound)="onRowDataBound($event)">
    <e-columns>
      <e-column field='id'
                [visible]='false'
                headerText="ID"
                isPrimaryKey="true">
      </e-column>
      <e-column field='vendorName'
                headerText="{{'i18n.domain.vendor-score-card.vendor-score-card-vendors.client-name'  | translate}}"
                clipMode='EllipsisWithTooltip'>
      </e-column>
      <e-column field='email'
                headerText="{{ 'i18n.shared.fields.email' | translate }}"
                clipMode='EllipsisWithTooltip'>
      </e-column>
      <e-column field='state'
                headerText="{{'i18n.domain.vendor-score-card.vendor-score-card-vendors.state'  | translate}}"
                clipMode='EllipsisWithTooltip'
                [filter]="checkBoxFilter">
        <ng-template #filterItemTemplate let-data>{{getStateName(data.state) | translate}}</ng-template>
        <ng-template #template let-data>
          {{getStateName(data.state) | translate}}
        </ng-template>
      </e-column>
      <e-column field='totalPoints'
                headerText="{{'i18n.domain.vendor-score-card.vendor-score-card-vendors.total-points' | translate}}"
                clipMode='EllipsisWithTooltip'
                format="N2">
      </e-column>
      <e-column field='modifiedOn'
                headerText="{{'i18n.domain.vendor-score-card.vendor-score-card-vendors.modified-on'  | translate}}"
                clipMode='EllipsisWithTooltip'
                type="dateTime"
                format="dd.MM.yyyy HH:mm">
      </e-column>
      <e-column headerText="" [commands]='gridCommands' width='110px' textAlign="left"></e-column>
    </e-columns>
  </ejs-grid>
  <ejs-dialog id='dialog' #dialog showCloseIcon='true' [visible]="false" width='435px'>
    <ng-template #footerTemplate>
          <button class="e-control e-btn e-primary" data-ripple="true" (click)="addVendor()">
            {{'i18n.shared.save' | translate}}
          </button>
      </ng-template>
      <ng-template #content>
        <div class="dialogContent">
          <form [formGroup]="form">
            <div class="mt-2">
              <label for="vendorName">{{ "i18n.shared.fields.name" | translate }}</label>
              <input id="vendorName" type="text" class="form-control"
                formControlName="vendorName">
              <app-error-messages [control]="form.controls.vendorName"></app-error-messages>
            </div>
            <div class="mt-2">
              <label for="email">{{ "i18n.shared.fields.email" | translate }}</label>
              <input id="email" type="text" class="form-control"
                formControlName="email">
              <app-error-messages [control]="form.controls.email"></app-error-messages>
            </div>
            <div class="mt-2">
              <label for="language">{{ 'i18n.domain.vendor-score-card.vendor-score-card-vendors.language' | translate }}</label>
              <ejs-dropdownlist id='language' [dataSource]='languages' [(value)]="selectedLanguage"></ejs-dropdownlist>
            </div>
          </form>
        </div>
      </ng-template>
      <ng-template #header>
          <div title="Add new Vendor" class="e-icon-settings dlg-template">
            {{'i18n.domain.vendor-score-card.vendor-score-card-vendors.add-new-vendor' | translate}}
          </div>
      </ng-template>
    </ejs-dialog>
</div>